import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
      <div className='expand-screen'>
        
      </div>
      <ul>
        <li>
          <h3 className='white-text'>Location</h3>
          <p className='primary'>
            Karachi, Pakistan
          </p>
        </li>
        <li>
          <h3 className='white-text'>E-mail</h3>
          <p className='primary'>
          mirzairtiza15@gmail.com
          </p>
        </li>
        <li>
          <h3 className='white-text'>Phone</h3>
          <p className='primary'>
          +92 302 9050 360
          </p>
        </li>
      </ul>
    </div>
  )
}
